import {
  createHourlyProvided,
  createHourlyRequirement,
  createHourlyWaste,
  HourlyEnergyFlow,
} from '../../HourlyEnergyFlow'
import {
  MultiTypeHourlyVariables,
  MultiTypeProvider,
} from './MultiTypeProvider'
import { InefficientParameters } from '../../../generated/graphql'

/**
 * Fully provides for the demand and requests the same amount of energy from the local grid.
 */
export abstract class LocalGridProvider extends MultiTypeProvider<InefficientParameters> {
  protected provideForHour({
    remainingDemands,
  }: MultiTypeHourlyVariables): HourlyEnergyFlow[] {
    const { efficiency } = this.parameters

    const consumptionFactor = 1 / efficiency
    const wasteFactor = (1 - efficiency) / efficiency

    const provideds = remainingDemands.map((flow) =>
      createHourlyProvided(flow.demandId, flow.energyType, flow.value),
    )

    const requirements = provideds.map((flow) =>
      createHourlyRequirement(
        flow.demandId,
        flow.energyType,
        flow.value * consumptionFactor,
      ),
    )

    const wastes =
      wasteFactor > 0
        ? provideds.map((flow) =>
            createHourlyWaste(
              flow.energyType,
              flow.energyType,
              flow.value * wasteFactor,
            ),
          )
        : []

    return [...provideds, ...requirements, ...wastes]
  }
}
